/* eslint-disable react/jsx-no-comment-textnodes */
import styles from './loader.module.css';

export const Loader = () => {
  return (
    <div className={styles.loaderContainer}>
      <div>
        <p className={styles.loadingWord}>LOADING...</p>
        <div className={styles.loader}></div>
        <p className={styles.verifyingWord}>///VERIFYING...</p>
      </div>
    </div>
  );
};
